import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Header } from "../../components/Header";
import { HeaderCategories } from "../../components/HeaderCategories";
import { Menu } from "../../components/Menu";

import { SubcategoryItem } from "../../components/SubcategoryItem";
import { useAppConfig } from "../../hooks/useAppConfig";
import { ConfigType } from "../../contexts/AppConfigContext";
import { Loading } from "../../components/Loading";
import "./index.css";
import { usePluginspace } from "../../hooks/usePluginspace";
import { useCategory } from "../../hooks/useCategory";
import { CategoryType } from "../../contexts/CategoryContext";
import { useQuery } from "../../hooks/useQuery";
import { useOrder } from "../../hooks/useOrder";
import { SellerBanner } from "../../components/SellerBanner/sellerBanner";
import EmptyState from "../../components/EmptyStates/EmptyState";

export function Subcategory() {
	const { category_id } = useParams();
	const { registerAccess } = usePluginspace();
	const { getSubcategories, getSubcategorySelected } = useCategory();
	const [subcategories, setSubcategories] = useState<Array<CategoryType>>([]);

	const { getAppConfig, saveBlockLayout, blockLayout } = useAppConfig();
	const [config, setConfig] = useState<ConfigType | void>();
	const [loading, setLoading] = useState(true);
	const [categorySelected, setCategorySelected] = useState<CategoryType | null>(null);
	const [loadingHeader, setLoadingHeader] = useState(true);
	const [showClassificationName, setShowClassificationName] = useState(true);
	const [useShadow, setUseShadow] = useState(true);
	const navigate = useNavigate();

	const query = useQuery();
	const orderContext = useOrder();


	async function createVendorCart() {
		if (query.get('vendor') !== undefined && query.get('vendor') !== '' && query.get('vendor') != null) {
			// gerar um carrinho informando qual o vendedor

			const x = query.get('vendor')

			const vendedorCPF = atob(x!)

			orderContext.cpfVendorByLink(vendedorCPF)
			orderContext.setSellerCpfCnpj(vendedorCPF);
			orderContext.setShouldUpdadeCustomerCart(true)


			registerAccess('subcategory', vendedorCPF, undefined, window.location.pathname)

			const orderToStorage = Object.assign(orderContext);
			if (orderToStorage.order !== undefined) {
				await orderContext.encryptOrderStorage(orderToStorage);
			}

		} else {
			registerAccess('subcategory')
		}
	}


	useEffect(() => {
		createVendorCart()
		getConfig();
	}, []);

	async function saveInfoSellerLinkCart() {
		if (orderContext.shouldUpdadeCart) {
			const orderToStorage = Object.assign(orderContext);
			await orderToStorage.encryptOrderStorage(orderToStorage)
		}
	}

	useEffect(() => {

		saveInfoSellerLinkCart();

	}, [orderContext.shouldUpdadeCart])

	useEffect(() => {
		getConfig();
	}, [category_id]);


	async function getConfig() {
		setLoading(true)
		setLoadingHeader(true);
		const conf = await getAppConfig()
		await orderContext.getSellerInfo()

		if (conf) {
			setShowClassificationName(conf.content.showClassificationName)
			 setUseShadow(!conf.content.removeShadow)
		}

		setConfig(conf);
		setLoadingHeader(false);
		await getSubs(conf)
		setLoading(false)
	};

	async function getSubs(conf: ConfigType | void) {
		let showOutStock = (conf && conf.content && conf.content.pdv && conf.content.pdv.showOutStock) ? conf.content.pdv.showOutStock : false;
		let orderCategory = (conf && conf.content && conf.content.orderCategory) ? conf.content.orderCategory : ''
		const newSubcategories = await getSubcategories(category_id ? category_id : '0', showOutStock, orderCategory);
		setCategorySelected(await getSubcategorySelected(category_id ? category_id : ''))
		setSubcategories(newSubcategories);
	}
	return (
		<div className="subcategory">

			<div className="content-subcategory">
				{!loadingHeader && (
					<Header
						background={
							config?.webappcolor.backgroundheader
								? config?.webappcolor.backgroundheader
								: "#F5F5F5"
						}
						colorIcon={
							config?.webappcolor.iconsheader
								? config.webappcolor.iconsheader
								: "#636363"
						}
						logo={config?.icon ? config.icon : ""}
						backgroundCart={
							config?.webappcolor.backgroundcart
								? config.webappcolor.backgroundcart
								: "#FFBA49"
						}
						fontCart={
							config?.webappcolor.fontcart
								? config.webappcolor.fontcart
								: "#000"
						}
						noSales={
							(config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
								? config.content.pdv.noSales
								: false
						}
						extraSpacingLeftMenu
					/>
				)}
				{loading ? (
					<div style={{ width: '100%', height: 'calc(100vh)' }}>
						<Loading
							type="spinningBubbles"
							color="#FFF"
							width={64}
							height={64}
						/>
					</div>
				) : (
					<>
						<HeaderCategories
							fontColor={
								config?.webappcolor.fonttitlebar
									? config.webappcolor.fonttitlebar
									: "#FFFFFF"
							}
							backgroundColor={
								config?.webappcolor.backgroundtitlebar
									? config.webappcolor.backgroundtitlebar
									: "#000000"
							}
							categories={[
								config?.template !== "food" &&
									config?.template !== "retail" &&
									categorySelected?.name
									? categorySelected.name
									: "",
							]}
							blockViewMode={config && config.content.noUseViewMode ? config.content.noUseViewMode : false}
							inBlocks={blockLayout}
							setInBlocks={saveBlockLayout}
						/>
						{/*Novo baner do vendedor caso o cliente recebeu o link dele */}
						<SellerBanner marginTop="6.5rem" marginBottom="-5.5rem" />
						{/*Continuação do fluxo */}


						{subcategories.length > 0 ? (
							<div className={!blockLayout ? "subcategory-items" : "subcategory-items-grid"}>
								{subcategories.map((sub) => (
									<SubcategoryItem
										legendColor={config?.webappcolor.fontcategory
											? config?.webappcolor.fontcategory
											: "#FFF"}
										blockFormat={blockLayout}
										showClassificationName={showClassificationName}
										item={sub}
										food={false}
										useShadow={useShadow}
										setLoading={setLoading}
										noShadow={config?.content.noShadow
											? config.content.noShadow
											: false} classe={""} />
								))}
							</div>
						) : (
							<div style={{ flex: 1, width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
								<EmptyState type={"category"} textButton={"Voltar"} colorIcon={config?.webappcolor.iconsheader
									? config.webappcolor.iconsheader
									: "#CEA127"}
									noShowBackground
									action={() => navigate(-1)}
								/>
							</div>
						)}

					</>
				)}
				{!loadingHeader && (
					<Menu
						activeMenu="category"
						fontColor={
							config?.webappcolor.iconsfooter
								? config?.webappcolor.iconsfooter
								: "#636363"
						}
						activeFontColor={
							config?.webappcolor.highlightfooter
								? config?.webappcolor.highlightfooter
								: "#000"
						}
						backgroundMenu={
							config?.webappcolor.backgroundfooter
								? config?.webappcolor.backgroundfooter
								: "#F5F5F5"
						}
						colorIcons={
							config?.webappcolor.iconsfooter
								? config?.webappcolor.iconsfooter
								: "#636363"
						}
						highlightColorIcons={
							config?.webappcolor.highlightfooter
								? config?.webappcolor.highlightfooter
								: "#636363"
						}
						backgroundCart={
							config?.webappcolor.backgroundcart
								? config.webappcolor.backgroundcart
								: "#FFBA49"
						}
						fontCart={
							config?.webappcolor.fontcart
								? config.webappcolor.fontcart
								: "#000"
						}
						noSales={
							(config && config?.content && config?.content.pdv && config?.content.pdv.noSales)
								? config.content.pdv.noSales
								: false
						}
					/>
				)}
			</div>
		</div>
	);
}
